/* ============================================================
   JGNT Tabs - comportamiento compartido  ·  v4

   Lo cargan blocks/jgnt-tabs.liquid y sections/jgnt-tabs.liquid.
   Si los dos estan en la misma pagina, el navegador pide el
   archivo una sola vez, pero igual se ejecutaria dos veces: de
   ahi la bandera global de abajo.

   ------------------------------------------------------------
   POR QUE LA BARRA DE PESTANAS LA ARMA JAVASCRIPT

   Un bloque padre NO puede leer los ajustes de sus hijos:
   {% content_for 'blocks' %} los imprime, pero no los expone en
   Liquid. O sea que desde el contenedor no hay forma de saber
   como se llama cada pestana para dibujar su boton.

   La salida es al reves: cada panel se imprime a si mismo con su
   nombre en data-jgnt-tab-label, y al cargar, este script
   recorre los paneles y arma la barra. Asi el orden de los
   botones sigue siempre al orden de los bloques en el editor.

   ------------------------------------------------------------
   NOVEDAD v2 - LA MEDIDA DE LA BARRA DE SCROLL

   Las imagenes de la seccion van de lado a lado, y para eso el
   CSS necesita saber cuanto mide la ventana SIN la barra de
   scroll. 100vw no sirve: incluye la barra, y en escritorio
   sobra ese ancho y aparece scroll horizontal.

   La barra tampoco esta donde uno esperaria. A partir de 990px
   assets/base.css pone html y body en overflow: hidden y el que
   scrollea es .page-wrapper, asi que hay que medirlo a EL. En
   movil no hay .page-wrapper con scroll propio y se mide la
   ventana. Si ninguno da algo util queda 0, que es el caso de
   los navegadores con barra flotante (moviles y Mac).

   ------------------------------------------------------------
   NOVEDAD v3 - BARRA DE AVANCE DEL CARRUSEL

   La pestana de carrusel puede llevar debajo una barra fina
   (.jgnt-tab-cards__bar) con un tramo oscuro que se mueve al
   deslizar. El largo del tramo es la parte visible de la pista y
   su posicion es cuanto se ha deslizado.

   OJO: un panel escondido mide 0, asi que la barra se vuelve a
   calcular cada vez que se abre una pestana, no solo al cargar.

   ------------------------------------------------------------
   NOVEDAD v4 - DESLIZAR ENTRE PESTANAS EN MOVIL (Oct 13 2026)

   Ver 'DESLIZAR ENTRE PESTANAS EN MOVIL' al final.
   ============================================================ */

(function () {
  if (window.jgntTabsReady) return;
  window.jgntTabsReady = true;

  function measureScrollbar() {
    var width = 0;

    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight) {
      width = wrapper.offsetWidth - wrapper.clientWidth;
    }

    if (width <= 0) {
      width = window.innerWidth - document.documentElement.clientWidth;
    }

    if (!(width > 0)) width = 0;

    document.documentElement.style.setProperty('--jgnt-scrollbar', width + 'px');
  }

  /* ---------- Barra de avance del carrusel ---------- */

  function updateBar(bar) {
    var panel = bar.closest('.jgnt-tab-cards');
    var track = panel ? panel.querySelector('.jgnt-tab-cards__track') : null;
    var thumb = bar.querySelector('.jgnt-tab-cards__thumb');
    if (!track || !thumb) return;

    var visible = track.clientWidth;
    var total = track.scrollWidth;

    /* Panel escondido (mide 0) o todo cabe: no hay nada que
       indicar. En el primer caso se recalcula al abrir la
       pestana. */
    if (!visible || total <= visible + 1) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;

    var barWidth = bar.clientWidth;
    var thumbWidth = Math.max(barWidth * (visible / total), 24);
    var maxScroll = total - visible;
    var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    var x = (barWidth - thumbWidth) * Math.min(Math.max(progress, 0), 1);

    thumb.style.width = thumbWidth + 'px';
    thumb.style.transform = 'translateX(' + x + 'px)';
  }

  function initBars(root) {
    var bars = root.querySelectorAll('.jgnt-tab-cards__bar');

    Array.prototype.forEach.call(bars, function (bar) {
      if (!bar.jgntBound) {
        var panel = bar.closest('.jgnt-tab-cards');
        var track = panel ? panel.querySelector('.jgnt-tab-cards__track') : null;

        if (track) {
          track.addEventListener(
            'scroll',
            function () {
              updateBar(bar);
            },
            { passive: true }
          );
        }

        bar.jgntBound = true;
      }

      updateBar(bar);
    });
  }

  function refreshAllBars() {
    initBars(document);
  }

  /* ---------- Pestanas ---------- */

  function build(root) {
    var strip = root.querySelector('.jgnt-tabs__strip');
    var panels = root.querySelectorAll('.jgnt-tabs__panel');
    if (!strip || !panels.length) return;

    strip.innerHTML = '';

    /* Una sola pestana no es una pestana: se esconde la barra y
       el panel se muestra suelto. */
    if (panels.length < 2) {
      strip.hidden = true;
      panels[0].hidden = false;
      root.setAttribute('data-jgnt-tabs-ready', '');
      initBars(root);
      return;
    }

    strip.hidden = false;

    Array.prototype.forEach.call(panels, function (panel, index) {
      var label = panel.getAttribute('data-jgnt-tab-label') || 'Tab ' + (index + 1);

      var tab = document.createElement('button');
      tab.className = 'jgnt-tabs__tab';
      tab.type = 'button';
      tab.textContent = label;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

      tab.addEventListener('click', function () {
        activate(root, index);
      });

      strip.appendChild(tab);
      panel.hidden = index !== 0;
    });

    root.setAttribute('data-jgnt-tabs-ready', '');
    initBars(root);
    warmImages(root);
  }

  /* Sep 26 2026: las fotos de las pestanas ocultas iban con
     loading=lazy y un panel con display:none no carga nada. Al
     cambiar de pestana la foto apenas empezaba a bajar y se veia el
     fondo blanco. Cuando la pagina ya termino de cargar, se piden y
     se decodifican las de los paneles ocultos, para que el cambio
     sea inmediato. No compite con la carga inicial. */
  function warmImages(root) {
    var run = function () {
      root.querySelectorAll('.jgnt-tabs__panel[hidden] img').forEach(function (img) {
        if (img.loading === 'lazy') img.loading = 'eager';
        if (img.decode) {
          var go = function () {
            img.decode().catch(function () {});
          };
          if (img.complete) go();
          else img.addEventListener('load', go, { once: true });
        }
      });
    };
    var idle = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2500 });
      else setTimeout(run, 400);
    };
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  /* Sep 25 2026: CAMBIO DE PESTANA SIN BRINCO.

     Las pestanas no miden lo mismo (en producto: Materiales 127px,
     Detalles 194px, Cuidados 220px; en el home, una fila de 4
     tarjetas contra una cuadricula de 8 productos). Al cambiar, todo
     lo de abajo saltaba de golpe esa diferencia.

     Ahora la caja de paneles anima su alto del viejo al nuevo, asi
     que lo de abajo se desliza en vez de saltar, y el panel nuevo
     entra con un fundido corto. Las dos animaciones son WAAPI sobre
     el propio elemento: al terminar no queda ningun estilo puesto.

     Mientras crece, la caja recorta (overflow hidden) para que el
     panel nuevo no se encime sobre lo de abajo antes de tiempo. */
  var REDUCED = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function activate(root, index) {
    var tabs = root.querySelectorAll('.jgnt-tabs__tab');
    var panels = root.querySelectorAll('.jgnt-tabs__panel');
    var box = root.querySelector('.jgnt-tabs__panels');
    var animate = box && box.animate && !(REDUCED && REDUCED.matches);
    var from = animate ? box.getBoundingClientRect().height : 0;

    if (box && box.jgntTabAnim) box.jgntTabAnim.cancel();

    Array.prototype.forEach.call(tabs, function (tab, i) {
      tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    Array.prototype.forEach.call(panels, function (panel, i) {
      panel.hidden = i !== index;
    });

    if (animate) {
      var to = box.getBoundingClientRect().height;
      var incoming = panels[index];

      /* Sin fundido en paneles con foto: entrar desde opacidad 0
         dejaba ver el fondo blanco (el flash). La foto ya esta
         precargada (warmImages), asi que el cambio directo es limpio.
         Los paneles de solo texto o productos conservan el fundido. */
      if (incoming && incoming.animate && !incoming.querySelector('.jgnt-tab-image, img.jgnt-tab-image__media')) {
        incoming.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
      }

      if (Math.abs(to - from) > 2) {
        var previousOverflow = box.style.overflow;
        box.style.overflow = 'hidden';
        box.jgntTabAnim = box.animate([{ height: from + 'px' }, { height: to + 'px' }], {
          duration: 280,
          easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
        });
        var done = function () {
          box.style.overflow = previousOverflow;
          box.jgntTabAnim = null;
        };
        box.jgntTabAnim.onfinish = done;
        box.jgntTabAnim.oncancel = done;
      }
    }

    /* El panel recien abierto ya tiene medidas: ahora si se puede
       calcular su barra. */
    initBars(root);
  }

  function boot() {
    measureScrollbar();

    var roots = document.querySelectorAll('[data-jgnt-tabs]');
    Array.prototype.forEach.call(roots, build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* La barra aparece y desaparece cuando la pagina crece o se
     encoge, no solo al cambiar el tamano de la ventana. Se vuelve
     a medir al terminar de cargar todo (imagenes incluidas) y en
     cada resize. Las barras de avance tambien, porque el ancho de
     la pista cambia con la ventana. */
  window.addEventListener('load', function () {
    measureScrollbar();
    refreshAllBars();
  });

  window.addEventListener('resize', function () {
    measureScrollbar();
    refreshAllBars();
  });

  document.addEventListener('shopify:section:load', boot);

  /* Oct 13 2026: DESLIZAR ENTRE PESTANAS EN MOVIL.

     En movil, deslizar el dedo a la izquierda sobre el contenido abre
     la pestana siguiente y a la derecha la anterior. Es exactamente lo
     mismo que tocar la pestana (activate), asi que la animacion de alto
     y el fundido son los de siempre. No da la vuelta: en la ultima no
     pasa nada.

     Solo manual. No hay autoplay ni nada que mueva la barra de
     pestanas: si la pestana nueva queda fuera de la vista de la barra,
     se queda ahi hasta que la deslices tu.

     Se ignora el gesto cuando:
       - empieza dentro de algo que ya scrollea de lado (carrusel de
         tarjetas, fila de productos, la propia barra de pestanas), para
         no robarle el gesto;
       - es mas vertical que horizontal (estas bajando la pagina);
       - es corto (menos de 50px).

     Los listeners son pasivos y nunca llaman preventDefault, asi que el
     scroll vertical de la pagina no se toca. Van en document (delegados)
     para que funcionen tambien con secciones que el editor recarga. */
  var SWIPE_MIN = 50;
  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var swipe = null;

  function scrollsSideways(el, stop) {
    while (el && el !== stop) {
      if (el.scrollWidth > el.clientWidth + 1) {
        var ox = getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      swipe = null;
      if (!MOBILE || !MOBILE.matches || event.touches.length !== 1) return;

      var target = event.target;
      var root = target.closest ? target.closest('[data-jgnt-tabs][data-jgnt-tabs-ready]') : null;
      if (!root) return;

      var strip = root.querySelector('.jgnt-tabs__strip');
      if (!strip || strip.hidden || (strip.contains(target) && strip.scrollWidth > strip.clientWidth + 1)) return;
      if (scrollsSideways(target, root)) return;

      var touch = event.touches[0];
      swipe = { root: root, x: touch.clientX, y: touch.clientY };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!swipe) return;
      var start = swipe;
      swipe = null;

      var touch = event.changedTouches[0];
      var dx = touch.clientX - start.x;
      var dy = touch.clientY - start.y;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.5) return;

      var tabs = start.root.querySelectorAll('.jgnt-tabs__tab');
      var current = -1;
      Array.prototype.forEach.call(tabs, function (tab, i) {
        if (tab.getAttribute('aria-selected') === 'true') current = i;
      });
      if (current < 0) return;

      var next = dx < 0 ? current + 1 : current - 1;
      if (next < 0 || next >= tabs.length) return;

      activate(start.root, next);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    function () {
      swipe = null;
    },
    { passive: true }
  );

  /* En el editor, al seleccionar un bloque hijo se abre la
     pestana que lo contiene. Sin esto, seleccionar el tercer
     panel en la barra lateral no mostraria nada. */
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest ? event.target.closest('.jgnt-tabs__panel') : null;
    if (!panel) return;

    var root = panel.closest('[data-jgnt-tabs]');
    if (!root) return;

    var panels = Array.prototype.slice.call(root.querySelectorAll('.jgnt-tabs__panel'));
    activate(root, panels.indexOf(panel));
  });
})();
